import {createStore} from 'vuex'
import {ethers} from "ethers";
import axios from "@/utils/axios";
import {ElMessage} from "element-plus";

export default createStore({
    state: {
        wallet_address: "",
        signger: null,
        wallet_type: null,
        sidebarOpen: false // 添加侧滑栏状态
    },
    getters: {},
    mutations: {
        toggleSidebar(state) {
            state.sidebarOpen = !state.sidebarOpen; // 切换侧滑栏状态
        },
        SET_WALLET_ADDRESS(state, address) {
            state.wallet_address = address
        },
        SET_SIGNER(state, signer) {
            state.signger = signer
        },
        SET_WALLET_TYPE(state, wallet_type) {
            state.wallet_type = wallet_type
        }
    },
    actions: {
        async connect_wallet({commit}, wallet_type) {

            console.log("wallet_type", wallet_type)

            let provider;
            let signer;
            let address;

            switch (wallet_type) {
                case 'metamask':
                    // if (window.ethereum && window.ethereum.isMetaMask) {
                    provider = new ethers.BrowserProvider(window.ethereum);
                    // 请求用户连接钱包
                    await window.ethereum.request({method: 'eth_requestAccounts'});
                    // } else {
                    //   // 弹出新窗口到 MetaMask 官网
                    //   window.open('https://metamask.io/', '_blank');
                    //   console.error('MetaMask is not installed!');
                    // }
                    break;
                case 'okx':
                    if (window.okxwallet) {
                        provider = new ethers.BrowserProvider(window.okxwallet);
                        await window.okxwallet.request({method: 'eth_requestAccounts'});
                    } else {
                        // 弹出新窗口到 OKX 官网
                        window.open('https://www.okx.com/', '_blank');
                        console.error('OKX Wallet is not installed!');
                    }
                    break;
                case 'gate':
                    if (window.gatewallet) {
                        provider = new ethers.BrowserProvider(window.gatewallet);
                        await window.gatewallet.request({method: 'eth_requestAccounts'});
                    } else {
                        // 弹出新窗口到 Gate Wallet 官网
                        window.open('https://www.gate.io/', '_blank');
                        console.error('Gate Wallet is not installed!');
                    }
                    break;
                default:
                    console.error('Unsupported wallet type!');
                    break;
            }

            if (provider) {
                // const chainId = ChainId.BNB; // BSC mainnet chain ID
                await provider.send('wallet_switchEthereumChain', [{chainId: '0x38'}]);
            }
            if (provider) {
                const accounts = await provider.send("eth_requestAccounts", []);
                signer = await provider.getSigner();
                console.log('signer', signer)
                console.log('accounts', accounts);
                address = accounts[0];
                console.log('address', address);


                //进行签名
                const currTime = new Date().getTime()
                const msg = "Welcome to login AI-R1!" + currTime;
                const signature = await signer.signMessage(msg);
                console.log("signature", signature)

                // const invitor = localStorage.getItem("invitor")
                // if (invitor) {
                const invitor = new URLSearchParams(window.location.search).get("invitor");
                console.log("invitor", invitor)


                const resp = await axios.post("/api/login", {
                    msg: msg,
                    signature: signature,
                    wallet: address,
                    invitor: invitor,
                })
                if (resp.data.code === 0) {
                    //保存 address 到 state的 wallet_address
                    commit('SET_WALLET_ADDRESS', address)

                    //保存 signer 到 state的 signger
                    commit('SET_SIGNER', signer)

                    commit('SET_WALLET_TYPE', wallet_type)
                } else {
                    ElMessage.error(resp.data.msg)
                }
                console.log("login resp", resp)


            }
        },
        disconnect() {
            this.commit('SET_WALLET_ADDRESS', "")
            this.commit('SET_SIGNER', null)
            this.commit('SET_WALLET_TYPE', null)
        }
    },
    modules: {}
})